document.addEventListener("DOMContentLoaded", function() {
    var list = document.getElementById("content-pages");

    // Array of specific slugs (the ones you want to show first)
    var specialSlugs = ['efter-motet', 'under-motet', 'innan-motet'];

    // Loop over each slug and move the corresponding element to the top of the list
    specialSlugs.forEach(function(slug) {
        var item = document.querySelector('.' + slug);
        if (item) {
            list.prepend(item); // Move the item to the top
        }
    });
});